import React from "react";
import ParagraphTag from "../../../reusebale/Paragraph";
import ImageTag from "../../../reusebale/imageTag";
import moment from "moment";
import { sumByKey } from "../../../../utils/subscriptionHelper";

const InfoSection = ({ tenantInfo }) => {
  return (
    <div>
      <div className="mt-3 flex justify-between">
        <div className="w-[49%] bg-white rounded-xl">
          <div className="px-4 pt-4">
            <ParagraphTag
              content="Personal Information"
              classes="text-darkColor font-popinsSemiBold text-lg mt-[-3px]"
            />
          </div>
          <div className="flex mt-1 items-center">
            <div className="w-[30%]">
              <ImageTag
                path={
                  tenantInfo?.personalInformation?.profileImage?.url ||
                  "/assets/daashboard/landlord-color.png"
                }
                classes="w-[170px] h-[170px] rounded-full p-3 object-cover"
                altText="logo"
              />
            </div>
            <div className="w-[70%]">
              <div className="pt-3">
                <ParagraphTag
                  content="Name"
                  classes="text-darkColor font-popinsSemiBold text-sm"
                />
                <ParagraphTag
                  content={`${tenantInfo?.personalInformation?.firstName} ${tenantInfo?.personalInformation?.lastName}`}
                  classes="text-darkColor/40 font-popinsRegular mt-[-2px] text-xs "
                />
              </div>
              <div className="pt-3">
                <ParagraphTag
                  content="Email Address"
                  classes="text-darkColor font-popinsSemiBold text-sm"
                />
                <ParagraphTag
                  content={tenantInfo?.personalInformation?.email}
                  classes="text-darkColor/40 font-popinsRegular mt-[-2px] text-xs "
                />
              </div>
              <div className="pt-2">
                <ParagraphTag
                  content="Cell Number"
                  classes="text-darkColor font-popinsSemiBold text-sm"
                />
                <ParagraphTag
                  content={tenantInfo?.personalInformation?.phoneNumber}
                  classes="text-darkColor/40 font-popinsRegular mt-[-2px] text-xs "
                />
              </div>
            </div>
          </div>
        </div>
        <div className="w-[49%] bg-white rounded-xl">
          <div className="px-4 pt-4">
            <ParagraphTag
              content="Company Info"
              classes="text-darkColor font-popinsSemiBold text-lg mt-[-3px]"
            />
          </div>
          <div className="flex mt-1 items-center">
            <div className="w-[30%]">
              <ImageTag
                path={
                  tenantInfo?.companyInformation?.companyLogo?.url ||
                  "/assets/daashboard/company-info-Round.png"
                }
                classes="w-[170px] h-[170px] object-cover rounded-full"
                altText="logo"
              />
            </div>
            <div className="w-[70%] px-2">
              <div className="pt-3">
                <ParagraphTag
                  content="Complete Address"
                  classes="text-darkColor font-popinsSemiBold text-sm"
                />
                <ParagraphTag
                  content={tenantInfo?.companyInformation?.completeAddress}
                  classes="text-darkColor/40 font-popinsRegular mt-[-2px] text-xs "
                />
              </div>
              <div className="pt-2 flex">
                <div className="w-[50%]">
                  <ParagraphTag
                    content="City"
                    classes="text-darkColor font-popinsSemiBold text-sm"
                  />
                  <ParagraphTag
                    content={tenantInfo?.companyInformation?.city}
                    classes="text-darkColor/40 font-popinsRegular mt-[-2px] text-xs "
                  />
                </div>
                <div className="w-[50%]">
                  <ParagraphTag
                    content="Country"
                    classes="text-darkColor font-popinsSemiBold text-sm"
                  />
                  <ParagraphTag
                    content={tenantInfo?.companyInformation?.country}
                    classes="text-darkColor/40 font-popinsRegular mt-[-2px] text-xs "
                  />
                </div>
              </div>
              <div className="pt-2 flex">
                <div className="w-[50%]">
                  <ParagraphTag
                    content="State"
                    classes="text-darkColor font-popinsSemiBold text-sm"
                  />
                  <ParagraphTag
                    content={tenantInfo?.companyInformation?.state}
                    classes="text-darkColor/40 font-popinsRegular mt-[-2px] text-xs "
                  />
                </div>
                <div className="w-[50%]">
                  <ParagraphTag
                    content="Zip Code"
                    classes="text-darkColor font-popinsSemiBold text-sm"
                  />
                  <ParagraphTag
                    content={tenantInfo?.companyInformation?.zipCode}
                    classes="text-darkColor/40 font-popinsRegular mt-[-2px] text-xs "
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="mt-3 flex justify-between">
        <div className="w-[49%] bg-white rounded-xl">
          <div className="px-4 pt-4 flex justify-between items-center">
            <ParagraphTag
              content="Subscription Information"
              classes="text-darkColor font-popinsSemiBold text-lg mt-[-3px]"
            />
            {/* <ParagraphTag
              content={"View All"}
              classes="text-themeColor font-popinsSemiBold text-sm cursor-pointer"
              onTrigger={() => onAction("Payment")}
            /> */}
          </div>
          <div className="flex mt-1 items-center pl-6 mb-5">
            <div className="w-[70%]">
              <div className="pt-3">
                <ParagraphTag
                  content="Plan Name"
                  classes="text-darkColor font-popinsSemiBold text-sm"
                />
                <ParagraphTag
                  content={
                    tenantInfo?.subscriptionPackage[0]?.packageData?.planName
                  }
                  classes="text-darkColor/40 font-popinsRegular mt-[-2px] text-xs "
                />
              </div>
              <div className="pt-3">
                <ParagraphTag
                  content="Plan End Date"
                  classes="text-darkColor font-popinsSemiBold text-sm"
                />
                <ParagraphTag
                  content={moment(
                    tenantInfo?.subscriptionPackage[0]?.endDate
                  ).format("MM/DD/YY")}
                  classes="text-darkColor/40 font-popinsRegular mt-[-2px] text-xs "
                />
              </div>
              <div className="pt-2">
                <ParagraphTag
                  content="Allowed Properties"
                  classes="text-darkColor font-popinsSemiBold text-sm"
                />
                <ParagraphTag
                  content={sumByKey(
                    tenantInfo?.subscriptionPackage,
                    "allowProperties"
                  )}
                  classes="text-darkColor/40 font-popinsRegular mt-[-2px] text-xs "
                />
              </div>
            </div>
          </div>
        </div>
        {/* <div className="w-[49%] bg-white rounded-xl">
          <div className="px-4 pt-4">
            <ParagraphTag
              content="Bank Information"
              classes="text-darkColor font-popinsSemiBold text-lg mt-[-3px]"
            />
          </div>
          <div className="flex mt-1 items-center">
            <div className="w-[70%] px-2 pl-6 mb-5">
              <div className="pt-3">
                <ParagraphTag
                  content="Holder Name"
                  classes="text-darkColor font-popinsSemiBold text-sm"
                />
                <ParagraphTag
                  content={tenantInfo?.bankInformation?.holderName}
                  classes="text-darkColor/40 font-popinsRegular mt-[-2px] text-xs "
                />
              </div>
              <div className="pt-2 flex">
                <div className="w-[50%]">
                  <ParagraphTag
                    content="Holder State"
                    classes="text-darkColor font-popinsSemiBold text-sm"
                  />
                  <ParagraphTag
                    content={tenantInfo?.bankInformation?.holderState}
                    classes="text-darkColor/40 font-popinsRegular mt-[-2px] text-xs "
                  />
                </div>
                <div className="w-[50%]">
                  <ParagraphTag
                    content="Holder City"
                    classes="text-darkColor font-popinsSemiBold text-sm"
                  />
                  <ParagraphTag
                    content={tenantInfo?.bankInformation?.holderCity}
                    classes="text-darkColor/40 font-popinsRegular mt-[-2px] text-xs "
                  />
                </div>
              </div>
              <div className="pt-2 flex">
                <div className="w-[50%]">
                  <ParagraphTag
                    content="Holder Zip Code"
                    classes="text-darkColor font-popinsSemiBold text-sm"
                  />
                  <ParagraphTag
                    content={tenantInfo?.bankInformation?.holderZip}
                    classes="text-darkColor/40 font-popinsRegular mt-[-2px] text-xs "
                  />
                </div>
              </div>
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default InfoSection;
